function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
  forgotPassword: path(ROOTS_AUTH, '/forgot-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,

  // === 🏠 HOME ===
  acreditados: {
    home: path(ROOTS_DASHBOARD, '/home'),
    dashboard: path(ROOTS_DASHBOARD, '/dashboard'),
    powerBI: path(ROOTS_DASHBOARD, '/Dirección'),
    store: path(ROOTS_DASHBOARD, '/Tienda'),
  },

  controlTable: {
    approvals: path(ROOTS_DASHBOARD, '/mesa-control/aprobaciones'),
    conversaciones: path(ROOTS_DASHBOARD, '/mesa-control/conversaciones'),
    conversacionesActualizarEstado: path(ROOTS_DASHBOARD, '/mesa-control/conversaciones/actualizar-estado'),
    requests: path(ROOTS_DASHBOARD, '/mesa-control/solicitudes'),
    personalLoans: path(ROOTS_DASHBOARD, '/mesa-control/prestamos-personales'),
    nips: path(ROOTS_DASHBOARD, '/mesa-control/nips-originacion'),
    nipsAuth: path(ROOTS_DASHBOARD, '/mesa-control/nips-autenticacion'),
    documentosPendientes: path(ROOTS_DASHBOARD, '/mesa-control/documentos-pendientes'),
  },

  employeeCredits: {
    payroll: path(ROOTS_DASHBOARD, '/creditos-empleados/nomina'),
  },

  clientes: {
    carteraAsignada: path(ROOTS_DASHBOARD, '/clientes/cartera-asignada'),
    clients: path(ROOTS_DASHBOARD, '/clientes/clientes'),
    clientsDetail: (id) => path(ROOTS_DASHBOARD, `/clientes/clientes/perfil-de-credito-detalle/${id}`),
    historyScore: path(ROOTS_DASHBOARD, '/clientes/clientes/historial-crediticio'),
  },

  campañas: {
    smsSettings: path(ROOTS_DASHBOARD, '/campanas/sms'),
    campaignsSettings: path(ROOTS_DASHBOARD, '/campanas/programacion'),
    massContact: path(ROOTS_DASHBOARD, '/campanas/contacto-masivo'),
    condonacion: path(ROOTS_DASHBOARD, '/campanas/condonacion-masiva'),
  },

  cartera: {
    portfolioAssignationSettings: path(ROOTS_DASHBOARD, '/cartera/asignar-gestores'),
    portfolioDespachoSettings: path(ROOTS_DASHBOARD, '/cartera/asignar-despachos'),
    segmentPortfolioMirrorReasignation: path(ROOTS_DASHBOARD, '/cartera/reasignacion-segmentos'),
  },

  corelifecycle: {
    categories: path(ROOTS_DASHBOARD, '/clc/categorias'),
    rulesAdministration: path(ROOTS_DASHBOARD, '/clc/administracion-de-reglas'),
    storesAdministration: path(ROOTS_DASHBOARD, '/clc/administracion-de-tiendas'),
    operationalNotifications: path(ROOTS_DASHBOARD, '/clc/notificaciones-operativas'),
    assignments: path(ROOTS_DASHBOARD, '/clc/asignaciones'),
  },

  seguridad: {
    root: path(ROOTS_DASHBOARD, '/configuracion/seguridad'),
    menus: path(ROOTS_DASHBOARD, '/configuracion/seguridad/roles-permisos'),
    employees: path(ROOTS_DASHBOARD, '/configuracion/seguridad/usuarios'),
  },

  rules: {
    root: path(ROOTS_DASHBOARD, '/configuracion/reglas'),
    liquidacion: path(ROOTS_DASHBOARD, '/configuracion/reglas/liquidacion-anticipada'),
    applicationDebtSettings: path(ROOTS_DASHBOARD, '/configuracion/reglas/pre-castigo'),
    condonacion: path(ROOTS_DASHBOARD, '/configuracion/reglas/condonacion'),
  },

  mantenimiento: {
    root: path(ROOTS_DASHBOARD, '/configuracion/mantenimiento'),
    cartera: path(ROOTS_DASHBOARD, '/configuracion/mantenimiento/cartera'),
    reasignacion: path(ROOTS_DASHBOARD, '/configuracion/mantenimiento/reasignacion'),
    castigo: path(ROOTS_DASHBOARD, '/configuracion/mantenimiento/castigo'),
    MovementsTable: (id) => path(ROOTS_DASHBOARD, `/configuracion/mantenimiento/documentos/${id}`),
    powerBI: path(ROOTS_DASHBOARD, '/configuracion/mantenimiento/power-bi'),
  },

  financialProducts: {
    root: path(ROOTS_DASHBOARD, '/configuracion/productos-financieros'),
    createProduct: path(ROOTS_DASHBOARD, '/configuracion/productos-financieros/alta'),
    productlist: path(ROOTS_DASHBOARD, '/configuracion/productos-financieros/gestion'),
    legalarioLifeproof: path(ROOTS_DASHBOARD, '/configuracion/productos-financieros/prueba-vida'),
    creditDecisionEngine: path(ROOTS_DASHBOARD, '/configuracion/productos-financieros/motor-de-decision'),
  },

  support: {
    root: path(ROOTS_DASHBOARD, '/configuracion/soporte'),
    password: path(ROOTS_DASHBOARD, '/configuracion/soporte/password'),
    documents: path(ROOTS_DASHBOARD, '/configuracion/soporte/documentos'),
    creditCircle: path(ROOTS_DASHBOARD, '/configuracion/soporte/circulo-credito'),
    reenviarLiga: path(ROOTS_DASHBOARD, '/configuracion/soporte/reenviar-liga'),
    regenerarLiga: path(ROOTS_DASHBOARD, '/configuracion/soporte/regenerar-liga'),
    incrementoLinea: path(ROOTS_DASHBOARD, '/configuracion/soporte/incremento-linea'),
    updateClientWatcher: path(ROOTS_DASHBOARD, '/configuracion/soporte/actualiza-saldo-cliente'),
  },

  payments: {
    root: path(ROOTS_DASHBOARD, '/configuracion/pagos'),
    configuration: path(ROOTS_DASHBOARD, '/configuracion/pagos/configuracion'),
    dispersion: path(ROOTS_DASHBOARD, '/configuracion/pagos/dispersion'),
    access: path(ROOTS_DASHBOARD, '/configuracion/pagos/habilitados'),
  },

  watcherReport: {
    root: path(ROOTS_DASHBOARD, '/watcher-report'),
  },

  contacto: {
    root: path(ROOTS_DASHBOARD, '/reportes/contacto'),
    contactoIndividualReport: path(ROOTS_DASHBOARD, '/reportes/contacto/individual'),
    contactoMassiveReport: path(ROOTS_DASHBOARD, '/reportes/contacto/masivo'),
  },

  castigo: {
    root: path(ROOTS_DASHBOARD, '/reportes/castigo'),
    goToCastigos: path(ROOTS_DASHBOARD, '/reportes/castigo/eventos'),
    castigoDetails: path(ROOTS_DASHBOARD, '/reportes/castigo/detalle'),
  },

  condonacion: {
    root: path(ROOTS_DASHBOARD, '/reportes/condonacion'),
    condonacionIndividualReport: path(ROOTS_DASHBOARD, '/reportes/condonacion/individual'),
    condonacionMassiveReport: path(ROOTS_DASHBOARD, '/reportes/condonacion/masiva'),
  },

  originacion: {
    root: path(ROOTS_DASHBOARD, '/reportes/originacion'),
    requests: path(ROOTS_DASHBOARD, '/reportes/originacion/reporte-solicitudes'),
    goToCredit: path(ROOTS_DASHBOARD, '/reportes/originacion/pases-credito'),
    credit: path(ROOTS_DASHBOARD, '/reportes/originacion/circulo-credito'),
    webappUsers: path(ROOTS_DASHBOARD, '/reportes/originacion/usuarios-webapp'),
  },

  configuracion: {
    root: path(ROOTS_DASHBOARD, '/reportes/configuracion'),
    segmentacionesSGC: path(ROOTS_DASHBOARD, '/reportes/configuracion/segmentaciones-sgc'),
    subsegmentacionesSGC: path(ROOTS_DASHBOARD, '/reportes/configuracion/subsegmentaciones-sgc'),
    configSmsEmails: path(ROOTS_DASHBOARD, '/reportes/configuracion/config-sms-emails'),
  },

  contactacion: {
    root: path(ROOTS_DASHBOARD, '/reportes/contactacion'),
    clientesPromesasPago: path(ROOTS_DASHBOARD, '/reportes/contactacion/clientes-promesas-pago'),
    trazabilidadClientes: path(ROOTS_DASHBOARD, '/reportes/contactacion/trazabilidad-clientes'),
    asiganacionesGestores: path(ROOTS_DASHBOARD, '/reportes/contactacion/asiganaciones-gestores'),
    mensajesHistoricos: path(ROOTS_DASHBOARD, '/reportes/contactacion/mensajes-historicos'),
  },

  campanas: {
    root: path(ROOTS_DASHBOARD, '/reportes/campanas'),
    campanasSGC: path(ROOTS_DASHBOARD, '/reportes/campanas/campanas-sgc'),
    condonacionesMasivas: path(ROOTS_DASHBOARD, '/reportes/campanas/condonaciones-masivas'),
    mensajesClientes: path(ROOTS_DASHBOARD, '/reportes/campanas/mensajes-clientes'),
  },

  gestores: {
    root: path(ROOTS_DASHBOARD, '/reportes/gestores'),
    montosRecuperados: path(ROOTS_DASHBOARD, '/reportes/gestores/montos-recuperados'),
    productividadGestores: path(ROOTS_DASHBOARD, '/reportes/gestores/productividad-gestores'),
  },

  castigoReportes: {
    root: path(ROOTS_DASHBOARD, '/reportes/castigo-reportes'),
    clientesPrescastigoCastigo: path(ROOTS_DASHBOARD, '/reportes/castigo-reportes/clientes-prescastigo-castigo'),
    eventosCastigoCartera: path(ROOTS_DASHBOARD, '/reportes/castigo-reportes/eventos-castigo-cartera'),
  },

  reportes: {
    paymentsMonitor: path(ROOTS_DASHBOARD, '/reportes/monitor-pagos'),
  },

  stores: {
    root: path(ROOTS_DASHBOARD, '/tiendas'),
    users: path(ROOTS_DASHBOARD, '/tiendas/usuarios'),
  },

  antifraude: {
    root: path(ROOTS_DASHBOARD, '/antifraude'),
    rules: path(ROOTS_DASHBOARD, '/antifraude/reglas'),
    blacklist: path(ROOTS_DASHBOARD, '/antifraude/blacklist'),
    ruleAudit: path(ROOTS_DASHBOARD, '/antifraude/auditoria-reglas'),
  },

  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/user/reece-chung/edit'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
